import { defineComponent as _defineComponent } from 'vue'
import { IFilter, IOption } from "@/domain/entities/filter/filter.types";

import { PropType, computed, ref } from "vue";

import FooterButton from "@/components/shared/button/FooterButton.vue";
import VocEditGuideMessage from "@/components/bbs/voc/VocEditGuideMessage.vue";
import DynamicSurveyField from "../survey/DynamicSurveyField.vue";
import {
  EmitDefinitionType,
  useEditableFilters,
} from "@/composables/shared/useEditableFilters";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";


const __default__ = {
  name: "RouteDemandSurveyEdit",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  filters: {
    type: Array as PropType<IFilter[]>,
    required: true,
  },
  createMode: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onChangedData", "onClickApplyBtn"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const emitDefinition: EmitDefinitionType<{ [key: string]: any }, any> = {
  onChangedData: (map: { [key: string]: any }) => {
    emit("onChangedData", map);
  },
};

const scrollContainer = ref<HTMLElement>();

const isDisabledFilter = (filter: IFilter) => {
  if (filter.isAutoFilled) {
    return true;
  }

  if (!filter.parentKey) {
    return false;
  }

  const parentFilter = props.filters.find((f) => f.key === filter.parentKey);
  if (!parentFilter) {
    return false;
  }

  return Array.isArray(parentFilter.selectedOptions)
    ? !parentFilter.selectedOptions.length
    : !parentFilter.selectedOptions;
};

const footerBtnTitle = computed(() =>
  props.createMode ? "신청하기" : "수정 완료"
);

const footerBtnDisabled = computed(() => {
  const requiredFilter = props.filters.filter((f) => !!f.essential);
  return (
    !requiredFilter.length ||
    !requiredFilter.every((filter) => !!filter.selectedOptions)
  );
});

const getValue = (filter: IFilter) => {
  if (filter.fieldType !== "text" && filter.fieldType !== "string") return;

  return Array.isArray(filter.selectedOptions)
    ? filter.selectedOptions?.[0]?.key
    : filter.selectedOptions?.key;
};

const onUpdateValue = (filter: IFilter, inputValue: any) => {
  const option: IOption = {
    key: inputValue,
    value: inputValue,
    name: inputValue,
  };
  updateData(filter, option);
};

const { updateData } = useEditableFilters(props.filters, emitDefinition);

const emitOnClickApplyBtn = () => {
  emit("onClickApplyBtn");
};

const __returned__ = { props, emit, emitDefinition, scrollContainer, isDisabledFilter, footerBtnTitle, footerBtnDisabled, getValue, onUpdateValue, updateData, emitOnClickApplyBtn, FooterButton, VocEditGuideMessage, DynamicSurveyField, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})